module.exports = __webpack_public_path__ + "img/slide4.c2ce387c.png";